import { Directive } from '@angular/core';

@Directive({
    selector: '[lp2Slide]'
})
export class SlideDirective {
    constructor() { }
}



// WEBPACK FOOTER //
// ./ts/app/shared/carousel/slide.directive.ts